import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, Input, Form, Spin, message } from 'antd';

const { Option } = Select;

const LoopRecordFlowDrawer = ({ visible, onClose, onSave, collectionVariables }) => {
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [collectionVariable, setCollectionVariable] = useState('');
  const [afterLast, setAfterLast] = useState('');
  const [forEach, setForEach] = useState('');

  const handleSave = () => {
    if (!name || !apiName || !afterLast || !forEach) {
      message.error('Please fill all required fields.');
      return;
    }

    const data = {
      name,
      apiName,
      description,
      collectionVariable,
      afterLast,
      forEach,
    };

    onSave(data);
    message.success('Loop Record saved successfully!');
    onClose();
  };

  return (
    <Drawer
      title="Loop Record"
      placement="right"
      onClose={onClose}
      zIndex={1002}   // higher than sidebar
      visible={visible}
      width={600}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={handleSave}>
            Done
          </Button>
        </div>
      }
    >
      <Form layout="vertical">
        {/* Name */}
        <Form.Item label="Name" required>
          <Input
            placeholder="Enter Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Item>

        {/* API Name */}
        <Form.Item label="API Name" required>
          <Input
            placeholder="Enter API Name"
            value={apiName}
            onChange={(e) => setApiName(e.target.value)}
          />
        </Form.Item>

        {/* Description */}
        <Form.Item label="Description">
          <Input.TextArea
            placeholder="Enter Description"
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Form.Item>

        {/* Collection Variable */}
        <Form.Item label="Collection Variable" required>
          <Select
            placeholder="Select Collection Variable"
            style={{ width: '100%' }}
            value={collectionVariable}
            onChange={(value) => setCollectionVariable(value)}
          >
            {collectionVariables?.map((variable) => (
              <Option key={variable} value={variable}>
                {variable}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* After Last */}
        <Form.Item label="After Last Node" required>
          <Select
            placeholder="Select After Last Action"
            style={{ width: '100%' }}
            value={afterLast}
            onChange={(value) => setAfterLast(value)}
          >
            <Option value="Get Records">Get Records</Option>
            <Option value="Update Records">Update Records</Option>
            <Option value="Create Records">Create Records</Option>
            <Option value="Decision">Decision</Option>
            <Option value="Delete Records">Delete Records</Option>
          </Select>
        </Form.Item>

        {/* For Each */}
        <Form.Item label="For Each Node" required>
          <Select
            placeholder="Select For Each Action"
            style={{ width: '100%' }}
            value={forEach}
            onChange={(value) => setForEach(value)}
          >
            <Option value="Get Records">Get Records</Option>
            <Option value="Update Records">Update Records</Option>
            <Option value="Create Records">Create Records</Option>
            <Option value="Decision">Decision</Option>
            <Option value="Delete Records">Delete Records</Option>
          </Select>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default LoopRecordFlowDrawer;
